import {useState, useEffect} from 'react';
import { changeDisable, setMaskGeneric, getPermission, showMessageError } from '../../../classes/functions';
import './people.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArrowAltCircleLeft, FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";

export default function People(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);
    
  const [listCidades, setListCidades] = useState([]);
  const [listEstados, setListEstados] = useState([]);
  const [listPaises, setListPaises] = useState([]);
  const [listTipos, setListTipos] = useState([]);

  const [codigo, setCodigo] = useState('');
  const [armazem, setArmazem] = useState('');
  const [cgc, setCgc] = useState('');
  const [razao_social, setRazaoSocial] = useState('');
  const [nome_fantasia, setNomeFantasia] = useState('');
  const [insc_estadual, setInscEstadual] = useState('');
  const [insc_municipal, setInscMunicipal] = useState('');
  const [ativo, setAtivo] = useState('');
  const [arquetipo, setArquetipo] = useState([]);
  const [cep, setCep] = useState('');
  const [tipo, setTipo] = useState('');
  const [controls_balance, setControlsBalance] = useState('');
  const [controls_pallet, setControlsPallet] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [bairro, setBairro] = useState('');
  const [complemento, setComplemento] = useState('');
  const [pais, setPais] = useState('');
  const [estado, setEstado] = useState('');
  const [cidade, setCidade] = useState('');

  useEffect(()=> {
    async function loadPeople(){
      if (id) {
        getOne(id, option);
      }
    }

    getData();
    loadPeople();

  },[]);

  function validForm() {
    if ((cgc !== '') && (razao_social !== '') && (numero !== '') && (nome_fantasia !== '') && (cep !== '') && (logradouro !== '') && (pais !== '') && (estado !== '') && (cidade !== '')) {
      return true;
    } else {
      return false;
    }
  }

  function save(e){
    setCarrying(true);
    e.preventDefault();

    if (validForm() === true) {
      let listAux = [];

      arquetipo.forEach(element => {
        if (element.checked) {
          listAux.push(element.id);
        }
      });
      
      const data = {
        row: {
          armazem: armazem,
          cgc: cgc.replace(/[./-]/g, ""),
          razao_social: razao_social,
          nome_fantasia: nome_fantasia,
          insc_estadual: insc_estadual,
          insc_municipal: insc_municipal,
          ativo: ativo,
          arquetipo: listAux,
          cep: cep,
          tipo: tipo,
          controls_balance: controls_balance,
          controls_pallet: controls_pallet,
          logradouro: logradouro,
          numero: numero,
          bairro: bairro,
          complemento: complemento,
          pais: pais,
          estado: estado,
          cidade: cidade,
        }
      }

      if (codigo) { 
        data.row.id = codigo;
        api.put("/api/people/put", data)
        .then((response) => {
            toast.success('Registro atualizado com sucesso.');
            history.push('/people');
          }
        ).catch((error) => {
          console.log(error);
          showMessageError(error.response.data);
          setCarrying(false);
        });
      } else {
        api.post("/api/people/post", data)
        .then((response) => {
            toast.success('Registro inserido com sucesso.');
            history.push('/people');
          }
        ).catch((error) => {
          console.log(error);
          showMessageError(error.response.data);
          setCarrying(false);
        });
      }
    } else {
      toast.error('Preencha todos os campos com * antes de salvar.');
      setCarrying(false);
    }
  }

  function getOne(id, option){
    api.get(`/api/people/getList?id=${id}&acceptsInative=${true}`)
    .then((response) => {
        setCodigo(response.data.row.id);
        setArmazem(response.data.row.armazem);
        setCgc(response.data.row.cgc);
        setRazaoSocial(response.data.row.razao_social);
        setNomeFantasia(response.data.row.nome_fantasia);
        setInscEstadual(response.data.row.insc_estadual);
        setInscMunicipal(response.data.row.insc_municipal);
        setAtivo(response.data.row.ativo);
        setControlsBalance(response.data.row.controls_balance);
        setControlsPallet(response.data.row.controls_pallet);
        setTipo(response.data.row.tipo);
        setCep(response.data.row.cep);
        setLogradouro(response.data.row.logradouro);
        setNumero(response.data.row.numero);
        setBairro(response.data.row.bairro);
        setComplemento(response.data.row.complemento);
        setPais(response.data.row.pais);
        setEstado(response.data.row.estado);
        setCidade(response.data.row.cidade);
        
        let auxArquetipo = [];
        let status = false;
        
        response.data.arquetipos.forEach(element => {
          status = false;
          response.data.row.arquetipo.forEach(item => {            
            if (item === element.chave) {
              status = true;
            }
          });
          auxArquetipo.push({
            id: element.chave,
            nome: element.descricao,
            ativo: element.ativo,
            checked: status,
          })
        });
        setArquetipo(auxArquetipo);

        setCarrying(false);
      }
    ).catch((error) => {
      console.log(error);
      showMessageError(error.response.data);

      setCarrying(false);
    });

    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/people');
  }

  function remove(){
    api.delete("/api/people/delete?id=" + id)
    .then((response) => {
        toast.success('Registro excluído com sucesso.');
        history.push('/people');
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }
  
  async function getData() {
    api.get("/api/people/getDataPage")
    .then((response) => {
      setListCidades(response.data.cidades);
      setListEstados(response.data.estados);
      setListPaises(response.data.paises);
      setListTipos(response.data.tipos);

      if (!id) {
        let listAux = [];

        response.data.arquetipos.forEach(element => {
          listAux.push({
            id: element.chave,
            nome: element.descricao,
            ativo: element.ativo,
            checked: false,
          })
        });

        setArquetipo(listAux);
      }

      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function searchCEP() {
    api.get("/api/utilities/getDataCEP?cep=" + cep)
    .then((response) => {
        setBairro(response.data.bairro);
        setCidade(response.data.localidade);
        setLogradouro(response.data.logradouro);
        setEstado(response.data.uf);
        setPais(response.data.pais);
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function searchCNPJ() {    
    api.get("/api/utilities/getDataCGC?cgc=" + cgc)
    .then((response) => {
        if (!response.data.row) {
          
        } else {
          toast.success('Cadastro já existente.');
          setCodigo(response.data.row.id);
          setArmazem(response.data.row.armazem);
          setCgc(response.data.row.cgc);
          setRazaoSocial(response.data.row.razao_social);
          setNomeFantasia(response.data.row.nome_fantasia);
          setArquetipo(response.data.row.arquetipo);
          setTipo(response.data.row.tipo);
          setInscEstadual(response.data.row.insc_estadual);
          setInscMunicipal(response.data.row.insc_municipal);
          setAtivo(response.data.row.ativo);
          setCep(response.data.row.cep);
          setLogradouro(response.data.row.logradouro);
          setNumero(response.data.row.numero);
          setBairro(response.data.row.bairro);
          setComplemento(response.data.row.complemento);
          setPais(response.data.row.pais);
          setEstado(response.data.row.estado);
          setCidade(response.data.row.cidade);
        
          let auxArquetipo = [];
          let status = false;
          
          response.data.arquetipos.forEach(element => {
            status = false;
            response.data.row.arquetipo.forEach(item => {
              if (item === element.chave) {
                status = true;
              }
            });
            auxArquetipo.push({
              id: element.chave,
              nome: element.descricao,
              checked: status,
            })
          });
          setArquetipo(auxArquetipo);
        }
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function keyCGC(e){
    let cgcKey = e.target.value;
    let cgcMask = "";

    if (cgcKey.length < 15) {
      cgcMask = setMaskGeneric(e.target.value, "###.###.###-##");
    } else {
      cgcMask = setMaskGeneric(e.target.value, "##.###.###/####-##");
    }

    setCgc(cgcMask);
  }

  function changeListArquetipo(e) {
    let auxListArquetipo = [];

    arquetipo.forEach(element => {
      if (element.id === e.target.value) {
        element.checked = !element.checked;
      }
      auxListArquetipo.push(element);
    });

    setArquetipo(auxListArquetipo);
  }
  
  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
            
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Cadastro de Pessoas">
          <Link to="/people">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais</h2>
              <hr></hr>
            
              <div className="divGroup">
                <div className="formDiv">
                  <label>CPF/CNPJ</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="CPF/CNPJ" value={cgc} onChange={keyCGC} onBlur={searchCNPJ} disabled={view} maxLength="18"/>
                </div>

                <div className="formDiv">
                  <label>Razão Social</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Razão Social" value={razao_social} onChange={ (e) => setRazaoSocial(e.target.value) } disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Nome Fantasia</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Nome Fantasia" value={nome_fantasia} onChange={ (e) => setNomeFantasia(e.target.value) } disabled={view}/>
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Inscrição Estadual</label><br/>
                  <input type="text" placeholder="Inscrição Estadual" value={insc_estadual} onChange={ (e) => setInscEstadual(e.target.value) } disabled={view} maxLength="18"/>
                </div>

                <div className="formDiv">
                  <label>Inscrição Municipal</label><br/>
                  <input type="text" placeholder="Inscrição Municipal" value={insc_municipal} onChange={ (e) => setInscMunicipal(e.target.value) } disabled={view} required/>
                </div>

                <div className="formDiv">
                  <label>Situação</label><br/>
                  <select value={ativo} onChange={ (e) => setAtivo(e.target.value) } disabled={view}>
                    <option>Selecione</option>
                    <option value="S">Ativo</option>
                    <option value="N">Inativo</option>
                  </select>
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Tipo</label><br/>
                  <select value={tipo} onChange={ (e) => setTipo(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listTipos.map((item, index) => (
                      <option key={index} value={item.chave}>{item.chave} - {item.descricao}</option>
                    ))}
                  </select>
                </div>
                
                <div className="formDiv">
                  <label>Controla Palete</label><br/>
                  <select value={controls_pallet} onChange={ (e) => setControlsPallet(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    <option value='S'>Sim</option>
                    <option value='N'>Não</option>
                  </select>
                </div>
                
                <div className="formDiv">
                  <label>Controla Saldo</label><br/>
                  <select value={controls_balance} onChange={ (e) => setControlsBalance(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    <option value='S'>Sim</option>
                    <option value='N'>Não</option>
                  </select>
                </div>
              </div>
            </div>
            <br/>
            <div className="containerGroupData">
              <h2>Endereço</h2>
              <hr></hr>

              <div className="divGroup">  
                <div className="formDiv">
                  <label>CEP</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="CEP" value={cep} onChange={ (e) => setCep(setMaskGeneric(e.target.value, "#####-###")) } onBlur={searchCEP} disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Logradouro</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Logradouro" value={logradouro} onChange={ (e) => setLogradouro(e.target.value) } disabled={view}/>
                </div>
                
                <div className="formDiv">
                  <label>Número</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Número" value={numero} onChange={ (e) => setNumero(e.target.value) } disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Bairro</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Bairro" value={bairro} onChange={ (e) => setBairro(e.target.value) } disabled={view}/>
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Complemento</label><br/>
                  <input type="text" placeholder="Complemento" value={complemento} onChange={ (e) => setComplemento(e.target.value) } disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Pais</label>&nbsp;<label className="required">*</label><br/>
                  <select value={pais} onChange={ (e) => setPais(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listPaises.map((item, index) => (
                      <option key={index} value={item.id}>{item.sigla} - {item.nome}</option>
                    ))}
                  </select>
                </div>

                <div className="formDiv">
                  <label>Estado</label>&nbsp;<label className="required">*</label><br/>
                  <select value={estado} onChange={ (e) => setEstado(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listEstados.map((item, index) => (
                      <option key={index} value={item.id}>{item.sigla} - {item.nome}</option>
                    ))}
                  </select>
                </div>

                <div className="formDiv">
                  <label>Cidade</label>&nbsp;<label className="required">*</label><br/>
                  <select value={cidade} onChange={ (e) => setCidade(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listCidades.map((item, index) => (
                      <option key={index} value={item.id}>{item.nome}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <br/>
            <div className="divGroup">
              <div className="formDivList">
                <div className="containerGroupData">
                  <h2>Arquetipos</h2>
                  <hr></hr>
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nome</th>
                      </tr>
                    </thead>
                    <tbody>
                      {arquetipo.map((item, index)=>{
                        if(item.ativo === 'S'){
                          return(
                            <tr key={index}>
                              <td data-label="#">
                                <input type="checkbox" checked={item.checked} value={item.id} onChange={ changeListArquetipo } />
                              </td>
                              <td data-label="Descrição">{item.nome}</td>
                            </tr>
                          )
                        }
                        
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="formDivList"></div>
            </div>
            {!view && <div className="formDiv">
              {getPermission('CADASTROS - PESSOAS - CADASTRO') && <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
              {id && getPermission('CADASTROS - PESSOAS - EXCLUSAO') && <button type="button" className="buttonRemove" onClick={remove} disabled={view}>Excluir</button>}
            </div>}
          </form>
        </div>
      </div>}
    </div>
  )
}